import { Condition, ActionData, Action } from './types/_types.actions';
import { path, assocPath, mergeDeepRight, append, without, has} from 'ramda';
import * as R from 'ramda';
import { normalizePath } from '../../packages/core/toolbox/objects/paths/normalize';
import { isObjectLike, isUndefined } from 'ramda-adjunct';


export const evaluateCondition = (condition: Condition, context: any): boolean => {
  if(isUndefined(condition) || !has("prop")) return false;
  const sutValue = path(normalizePath(condition.prop), context) as any;
  const toCompareValue = condition.value;
  switch (condition.operator) {
    case undefined:
    case 'includes':
      return Array.isArray(toCompareValue)
        ? toCompareValue.includes(sutValue)
        : isObjectLike(toCompareValue)
          ? has(sutValue,toCompareValue)
          : sutValue === toCompareValue;
    case 'excludes':
      return Array.isArray(toCompareValue)
        ? !toCompareValue.includes(sutValue)
        : isObjectLike(toCompareValue)
          ? !has(sutValue,toCompareValue)
          : sutValue !== toCompareValue;
    default:
      return false;
  }
};

export const applyActions = (props: any, actions: Action[], context: any): any => {
  return actions.reduce((acc, action) => {
    if (evaluateCondition(action.condition, context)) {
      if ('data' in action) {
        return action.data.reduce((innerAcc, data) => applyAction(innerAcc, data as any,context), acc);
      } else {
        return applyAction(acc, action,context);
      }
    }
    return acc;
  }, props);
};

const applyAction = (props: any, action: Action, context: any): any => {
  const { condition: { prop:conditionProp, value: conditionValue}, prop,value, operation = 'replace' } = action as any;
  const propPath = normalizePath(prop);
  switch (operation) {
    case 'replace':
      return assocPath(propPath, value, props);
    case 'replace_by_Key':
      return assocPath(propPath, path(normalizePath(R.prop(conditionProp,context)), value), props);
    case 'merge':
      return assocPath(propPath, mergeDeepRight(path(propPath, props) as any, value), props);
    case 'add':
      return assocPath(propPath, append(value, path(propPath, props) as any), props);
    case 'remove':
      return assocPath(propPath, without([value], path(propPath, props) as any), props);
    default:
      return assocPath(propPath, value, props);
  }
};
